import React from 'react'
import { useTranslation } from 'next-i18next'
import WeHelpYouImage from '@/images/we-help-you.svg'
import Image from 'next/image'

const WeHelpYou = () => {
  const { t } = useTranslation()

  return (
    <div className='w-full bg-white py-[60px] md:pt-[100px] md:pb-[80px]'>
      <div className='max-w-[90%] mx-auto'>
        <div className='flex flex-col-reverse md:flex-row items-center justify-between gap-[40px] lg:gap-[80px]'>
          <div className='flex-1 flex flex-col gap-[20px] w-full lg:max-w-[70%]'>
            <h2 className='text-[32px] md:text-[48px] font-[600] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]'>
              {t('programs-page.hero-slide-down-new-title')}
            </h2>
            <p className='text-[14px] md:text-[20px] font-[400] leading-[160%]'>
              {t('programs-page.hero-slide-down-new-subtitle')}
            </p>
          </div>
          <div className='flex-1 flex items-center justify-center w-full xs:max-w-[70%] lg:max-w-[30%]'>
            <div className='relative max-w-[465px] lg:max-w-[488px]' style={{ aspectRatio: '465 / 488' }}>
              <Image src={WeHelpYouImage} alt='We Help You' fill className='object-contain max-w-[465px] lg:max-w-[488px]' />
              <div className='relative w-full h-full grid grid-cols-2 grid-rows-2'>
                <div />
                <div className='flex flex-col items-center justify-center px-2'>
                  <span className='text-main-pink font-[600] leading-[1.2] whitespace-nowrap' style={{ fontSize: 'clamp(18px, 4vw, 30px)' }}>
                    {t('programs-page.hero-slide-right-circle1', {
                      count: t('programs-page.we-help-you-students-count'),
                    })}
                  </span>
                  <span className='text-[14px] md:text-[18px] font-[500] leading-[160%] text-gray-500'>
                    {t('programs-page.hero-slide-right-circle1-text')}
                  </span>
                </div>
                <div className='flex flex-col items-center justify-center px-2'>
                  <span className='text-main-pink font-[600] leading-[1.2] whitespace-nowrap' style={{ fontSize: 'clamp(16px, 3.5vw, 20px)' }}>
                    {t('programs-page.hero-slide-right-circle2', {
                      amount: t('programs-page.we-help-you-scholarship-amount'),
                    })}
                  </span>
                  <span className='text-[14px] md:text-[18px] font-[500] leading-[160%] text-gray-500'>
                    {t('programs-page.hero-slide-right-circle2-text')}
                  </span>
                </div>
                <div />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WeHelpYou
